import AOS from "aos";
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";
import Cookies from "../../node_modules/js-cookie/src/js.cookie.js";

(function () {
    "use strict";

    // Allows us to add classes in Gutenberg to trigger AOS animations
    jQuery(".fade-up").attr("data-aos", "fade-up");
    jQuery(".fade-right").attr("data-aos", "fade-right");

    // AOS Init
    AOS.init({
        once: true,
    });

    // Init
    navToggle();
    dropdownToggle();
    notificationBar();
    cookieBar();
    slideshowBlock();
    testimonialSlideShow();
    providerSlideShow();
    faq();
    socialSharing();
    imageWithSlideshow();
    secondaryNavToggle();
    searchToggle();
    linkBarToggle();
    physiciansMobileToggle();

    function navToggle() {
        $(".navicon").click(function () {
            $("body").toggleClass("nav-is-active");
        });
    }

    function dropdownToggle() {
        $(".dropdown-toggle").click(function () {
            $(this).parent().parent().toggleClass("dropdown-is-active");
            $(this)
                .parent()
                .parent()
                .siblings(".dropdown-is-active")
                .removeClass("dropdown-is-active");
            $("body").removeClass("search-is-active");

            if (
                !$(this).parent().parent().parent().is("#menu-secondary-menu")
            ) {
                $("body").removeClass("secondary-nav-is-active");
            }
        });
    }

    // Slideshow Block
    function slideshowBlock() {
        if ($(".b40-slideshow--slides").length > 0) {
            var slider = tns({
                container: ".b40-slideshow--slides",
                controls: false,
                navPosition: "bottom",
            });
        }
    }

    function notificationBar() {
        var cookieName = $('input[name="cookie_name"]').val(),
            cookieExpire = $('input[name="cookie_expire_date"]').val(),
            notificationBar = $(".notification-bar"),
            showBar = true,
            expires = {};

        if (cookieExpire) {
            cookieExpire = cookieExpire.split("-");
            var cookieExpireDate = new Date(
                cookieExpire[0],
                cookieExpire[1] - 1,
                cookieExpire[2]
            );
            expires = { expires: cookieExpireDate };
        }

        // Don't show the bar if the user has already closed it
        if ("hide" === Cookies.get(cookieName)) {
            showBar = false;
        }

        // Show the bar
        if (notificationBar.length > 0 && true === showBar) {
            notificationBar.slideToggle();
        }

        // Hide the bar and create a cookie if needed
        $(".notification-close").click(function (e) {
            e.preventDefault();
            notificationBar.slideToggle();

            if (cookieName) {
                Cookies.set(cookieName, "hide", expires);
            }
        });
    }

    function cookieBar() {
        var cookie = Cookies.get("cookie_notice");

        if (cookie != "hide") {
            $(".b40-cookie-notice").show();
        }

        $(".b40-cookie-notice a").click(function (e) {
            e.preventDefault();

            Cookies.set("cookie_notice", "hide");

            $(".b40-cookie-notice").slideUp();
        });
    }

    // Testimonial Slideshow
    function testimonialSlideShow() {
        if ($(".b40-testimonials-slider").length > 0) {
            var slider = tns({
                autoHeight: true,
                container: ".b40-testimonials-slider",
                controls: false,
                navPosition: "bottom",
            });
        }
    }

    // Mid-Level Provider Slideshow
    function providerSlideShow() {
        if ($(".mid-level-providers-carousel").length > 0) {
            var slider = tns({
                autoHeight: true,
                container: ".mid-level-providers-carousel",
                controls: true,
                navPosition: "bottom",
                items: 2,
                gutter: 20,
                controlsText: ["", ""],
                responsive: {
                    768: {
                        items: 3,
                    },
                },
            });
        }
    }

    // Prevent url bar from changing on faq anchor click
    function faq() {
        // List View Click
        $(".b40-faq-questions li a").click(function (e) {
            e.preventDefault();

            var hash = $(this).attr("href"),
                offset = 0;

            if ($("body.customize-support").length) {
                offset = 32;
            }

            $("html, body").animate(
                { scrollTop: $(hash).offset().top - offset },
                0
            );
        });

        $(".b40-faq-top").click(function (e) {
            e.preventDefault();
            $(window).scrollTop(0);
        });

        // Accordion Toggle
        $(".b40-faq-accordion .b40-faq-question").click(function (e) {
            var item = $(this).parent();

            if (item.hasClass("active")) {
                item.removeClass("active");
                $(this).next(".b40-faq-answer").slideToggle();
            } else {
                item.addClass("active");
                item.siblings().removeClass("active");
                item.siblings().find(".b40-faq-answer").slideUp();
                $(this).next(".b40-faq-answer").slideToggle();
            }
        });
    }

    // Social Sharing
    function socialSharing() {
        $(".facebook-share").click(function (e) {
            e.preventDefault();

            var url = $(this).attr("data-url");

            window.open(
                "https://www.facebook.com/sharer/sharer.php?u=" + url,
                "pop",
                "width=600, height=400, scrollbars=no"
            );
            return false;
        });

        $(".twitter-share").click(function (e) {
            e.preventDefault();

            var url = $(this).attr("data-url");

            window.open(
                "https://twitter.com/intent/tweet?url=" + url,
                "pop",
                "width=600, height=400, scrollbars=no"
            );
            return false;
        });

        $(".linkedin-share").click(function (e) {
            e.preventDefault();

            var url = $(this).attr("data-url");

            window.open(
                "https://www.linkedin.com/shareArticle?mini=true&url=" + url,
                "pop",
                "width=600, height=400, scrollbars=no"
            );
            return false;
        });
    }

    function imageWithSlideshow() {
        if ($(".b40-image-slideshow--slides").length > 0) {
            var slider = tns({
                container: ".b40-image-slideshow--slides",
                controls: false,
                navPosition: "bottom",
            });
        }
    }

    function secondaryNavToggle() {
        $(".secondary-nav-button").click(function () {
            $("body").toggleClass("secondary-nav-is-active");
            $("body").removeClass("search-is-active");
            $(".dropdown-toggle")
                .parent()
                .parent()
                .removeClass("dropdown-is-active");
        });
    }

    function searchToggle() {
        $(".search-button").on("click", function () {
            $("body").toggleClass("search-is-active");
            $("body").removeClass("secondary-nav-is-active");
            $(".dropdown-toggle")
                .parent()
                .parent()
                .removeClass("dropdown-is-active");
            $("#s").trigger("focus");
        });

        $(".search-icon-close").on("click", function () {
            $("body").toggleClass("search-is-active");
            $("body").removeClass("secondary-nav-is-active");
        });
    }

    function linkBarToggle() {
        if ($(".b40-sidebar-mobile-toggle").length > 0) {
            $(".b40-sidebar-mobile-toggle").click(function () {
                $(this).parent().toggleClass("active");
            });
        }
    }

    function physiciansMobileToggle() {
        if ($(".filter-bar").length > 0) {
            $(".filter-bar").click(function () {
                $(this).parent().toggleClass("active");
            });
        }
    }
})();
